import { ref, computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

export const usePrint = () => {
  const i18n = getI18n()
  const printToolbarButton = {}
  const printOptionsToolbarButton = {}
  const printDialogVisible = ref(false)
  const printCooldown = ref(false)
  const PRINT_COOLDOWN_MS = 1500

  const printToolbarWidget = (options = null) => {
    const originalOnClick = options?.onClick

    return {
      widget: 'dxButton',
      location: 'after',
      options: {
        ...options,
        icon: 'mdi mdi-printer',
        disabled: computed(() => printCooldown.value),
        hint: i18n.t('common.print'),
        onClick: async(e) => {
          if (printCooldown.value) return

          try {
            printCooldown.value = true
            await originalOnClick?.(e)
          } finally {
            setTimeout(() => { printCooldown.value = false }, PRINT_COOLDOWN_MS)
          }
        },
        onInitialized: (e) => { printToolbarButton.value = e.component }
      }
    }
  }

  const printOptionsToolbarWidget = (options = null) => ({
    widget: 'dxButton',
    location: 'after',
    options: {...{
      icon: 'mdi mdi-printer-search',
      disabled: true,
      hint: i18n.t('common.printSettings'),
      onClick: async() => { printDialogVisible.value = true },
      onInitialized: (e) => { printOptionsToolbarButton.value = e.component }
    }, ...options}
  })

  return { printToolbarWidget, printOptionsToolbarWidget, printToolbarButton, printOptionsToolbarButton, printDialogVisible }
}
